import store from "@/store";
import { CheckAuthorizeStatusAsync,
        CheckAuthorizeStatusAsyncAndCloseModal,
         CheckSubscriptionStatusAsync,
         CheckSubscriptionStatusAndCloseModalAsync } from "../authService";

export async function getJobListingsAsync(page){
try{
const url = `${process.env.VUE_APP_API_URL}Vacancy/JobListings?pageNumber=${page}`;
// Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Authorization': token != null? `Bearer ${token}` : ``
    }
  });
  return response.json();
}catch(e){
  throw new Error(e.message);
}
}

export async function getJobPostAsync(jobId){
try{
const url = `${process.env.VUE_APP_API_URL}Vacancy/GetOne/${jobId}`;
// Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Authorization': token != null? `Bearer ${token}` : ``
    }
  });
  return response.json();
}catch(e){
  throw new Error(e.message);
}
}

export async function SendJobApplicationAsync(formData, closeModal){
const url = `${process.env.VUE_APP_API_URL}Vacancy/Apply`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      // 'Content-Type': 'multipart/form-data',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    },
    body: formData
  });

  let checkSubscriptionResponse = response.clone();
  let checkAuthorizeStatusResponse = response.clone();

  await CheckSubscriptionStatusAndCloseModalAsync(checkSubscriptionResponse, closeModal);
  
  //await CheckAuthorizeStatusAsync(checkAuthorizeStatusResponse);
  await CheckAuthorizeStatusAsyncAndCloseModal(checkAuthorizeStatusResponse, closeModal);
  return response.json();
}

export async function ToggleSaveJobAsync(jobId,hidePreviewModal){
const url = `${process.env.VUE_APP_API_URL}Vacancy/SaveJob/${jobId}`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Authorization': token != null? `Bearer ${token}` : ``
    }
  });
  
  await CheckAuthorizeStatusAsyncAndCloseModal(response,hidePreviewModal)
  //await CheckAuthorizeStatusAsync(response);
  return response.json();
}


export async function getAppliedJobsAsync(page){
try{
const url = `${process.env.VUE_APP_API_URL}Vacancy/AppliedJobs?pageNumber=${page}`;
// Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Authorization': token != null? `Bearer ${token}` : ``
    }
  });

  let checkSubscriptionResponse = response.clone();
  let checkAuthorizeStatusResponse = response.clone();
  await CheckSubscriptionStatusAsync(checkSubscriptionResponse);
  await CheckAuthorizeStatusAsync(checkAuthorizeStatusResponse);

  return response.json();
}catch(e){
  throw new Error(e.message);
}
}

export async function getSavedJobsAsync(page){
try{
const url = `${process.env.VUE_APP_API_URL}Vacancy/SavedJobs?pageNumber=${page}`;
// Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Authorization': token != null? `Bearer ${token}` : ``
    }
  });

  let checkSubscriptionResponse = response.clone();
  let checkAuthorizeStatusResponse = response.clone();
  await CheckSubscriptionStatusAsync(checkSubscriptionResponse);
  await CheckAuthorizeStatusAsync(checkAuthorizeStatusResponse);

  return response.json();
}catch(e){
  throw new Error(e.message);
}
}

export async function searchJobsAsync(body, page){
try{
const url = `${process.env.VUE_APP_API_URL}Vacancy/PublicSearch?pageNumber=${page}`;
// Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': token != null? `Bearer ${token}` : ``
    },
    body: JSON.stringify(body)
  });
  return response.json();
}catch(e){
  throw new Error(e.message);
}
}

export async function searchPublicUsersAsync(body, page){
try{
const url = `${process.env.VUE_APP_API_URL}Auth/Search?pageNumber=${page}`;
// Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': token != null? `Bearer ${token}` : ``
    },
    body: JSON.stringify(body)
  });
  return response.json();
}catch(e){
  throw new Error(e.message);
}
}



